import { render, staticRenderFns } from "./ManageVersion.vue?vue&type=template&id=b66d55be&"
import script from "./ManageVersion.vue?vue&type=script&lang=js&"
export * from "./ManageVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports